
const finances = [
    [ '0',  'filter.secteur.none'],
    [ '99',  'filter.secteur.99'],
    [ '100',  'filter.secteur.100-999'],
    [ '1',  'filter.secteur.1m']
];

export default finances;